import { render, staticRenderFns } from "./SeasonListV1.vue?vue&type=template&id=f63115d6&scoped=true"
import script from "./SeasonListV1.vue?vue&type=script&setup=true&lang=ts"
export * from "./SeasonListV1.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SeasonListV1.vue?vue&type=style&index=0&id=f63115d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63115d6",
  null
  
)

export default component.exports